import type { ReactNode } from 'react';
import React, { useCallback, useState } from 'react';
import { type DrawerMenuItem, type MobileHeaderPageStackItem, type SiteConfig } from '@cx-web/domain-types';

import WrappedIcon from '../../../WrappedIcon/index';
import SubComponent from '../SubComponent/index';

import styles from './LinkWithPage.module.css';

interface LinksPage {
  bookmakers: SiteConfig['bookmakers'];
  callback?: (text: string) => void;
  hideIcons?: boolean;
  label: string;
  page: DrawerMenuItem;
  pageClick: (item: MobileHeaderPageStackItem) => void;
  renderMenuLinks?: (pages: DrawerMenuItem[], label: string) => ReactNode;
  serverUrl: string;
}

const LinksPage = ({
  bookmakers,
  callback,
  hideIcons,
  label,
  page: { groups = [], icon = '', items = [], itemsType, name, subLinks = [], type },
  pageClick,
  renderMenuLinks,
  serverUrl,
}: LinksPage): React.JSX.Element | null => {
  const [showLinksPage, setShowLinksPage] = useState(false);

  const handlePageClick = useCallback(() => {
    setShowLinksPage(showLinks => !showLinks);
    // @ts-ignore
    pageClick({ label: name, clickEvent: () => setShowLinksPage(false) });
  }, [name, pageClick]);

  if (!name) {
    return null;
  }

  return (
    <div>
      <div
        className={styles.link}
        data-testid="page-links"
        key={name}
        onClick={handlePageClick}
        role="button"
        tabIndex={0}
      >
        <WrappedIcon
          containerClassName={styles.iconContainer}
          hideIcon={hideIcons}
          iconClassName={styles.linkIcon}
          iconString={icon}
        />
        <div className={styles.linkText}>{name}</div>
        <div className={styles.arrow}></div>
      </div>
      <SubComponent
        bookmakers={bookmakers}
        callback={callback}
        groups={groups}
        items={items}
        itemsType={itemsType}
        label={label}
        name={name}
        pageClick={pageClick}
        renderMenuLinks={renderMenuLinks}
        serverUrl={serverUrl}
        showLinksPage={showLinksPage}
        subLinks={subLinks}
        type={type}
      />
    </div>
  );
};

export default LinksPage;
